import { Button, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

const PRIORITY_OPTIONS = ['HIGH', 'MEDIUM', 'LOW', 'INFORMATIVE'] as const;

type TaskPriorityColumnFilterPropsType = {
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  onClose: () => void;
};

export const TaskPriorityColumnFilter: React.FC<
  TaskPriorityColumnFilterPropsType
> = ({ value, onChange, onClose }) => {
  const { t } = useTranslation('tasks');

  return (
    <Stack gap={4}>
      {PRIORITY_OPTIONS.map((priority) => (
        <Button
          key={priority}
          fullWidth
          justify="flex-start"
          variant={value === priority ? 'light' : 'subtle'}
          onClick={() => {
            onChange(value === priority ? undefined : priority);
            onClose();
          }}
        >
          {t(`PRIORITY.${priority}`)}
        </Button>
      ))}
    </Stack>
  );
};
